// extracted by mini-css-extract-plugin
module.exports = {"section":"style_section__3R8Q3","container":"style_container__25mPK","row":"style_row__1whxG","fadeInUp":"style_fadeInUp__DuhlY"};